import React from 'react';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
export function TenorTab() {
  return <div className="space-y-6 max-w-4xl animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-922">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-923">
        <Select label="Tenor Unit" options={[{
        value: 'days',
        label: 'Days'
      }, {
        value: 'weeks',
        label: 'Weeks'
      }, {
        value: 'months',
        label: 'Months'
      }]} data-id="element-924" />

        <Input type="number" label="Minimum Tenor" placeholder="e.g. 12" required data-id="element-925" />

        <Input type="number" label="Maximum Tenor" placeholder="e.g. 60" required data-id="element-926" />

        <Input type="number" label="Default Tenor" placeholder="e.g. 24" data-id="element-927" />
      </div>
    </div>;
}